import { createAction } from '@reduxjs/toolkit';
import { useMemo } from 'react';

import {
    IDENTITY_VERIFICATION_STEPS,
    FORM_STEP,
} from '@perpay-web/fintech/constants/steps/identityVerificationSteps';
import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const identityVerificationStepsSetStep = createAction(
    'IDENTITY_VERIFICATION_STEPS::SET_STEP',
    (step) => ({ payload: step }),
);

const providerFactory = (Context) => {
    const Provider = ({ children, initialStep = FORM_STEP }) => {
        const hook = useSteps(IDENTITY_VERIFICATION_STEPS, initialStep);

        useActionObservableCallback(
            hookAction$,
            identityVerificationStepsSetStep().type,
            (step) => hook.setStep(step),
        );

        const contextValue = useMemo(
            () => ({
                step: hook.step,
                setStep: hook.setStep,
                goBack: hook.goBack,
            }),
            [hook.step, hook.setStep, hook.goBack],
        );

        return (
            <Context.Provider value={contextValue}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    IdentityVerificationStepsProvider,
    useIdentityVerificationStepsContext,
] = createContextProvider(providerFactory);
